// src/hooks/useMe.js
// Perfil del usuario autenticado (GET /auth/me). Forma igual a la que usaban los componentes.
import { useEffect, useState } from 'react';
import { fetchMe } from '../services/session';
import { getToken } from '../services/api';

export function useMe() {
  const [me, setMe] = useState({ loaded: false, uid: null, email: '', role: 'viewer', sucursalId: null, username: '' });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!getToken()) {
        if (!cancelled) setMe({ loaded: true, uid: null, email: '', role: 'viewer', sucursalId: null, username: '' });
        return;
      }
      try {
        const p = await fetchMe();
        if (!cancelled) setMe({ loaded: true, uid: p.uid, email: p.email || '', role: p.role || 'viewer', sucursalId: p.sucursalId || null, username: p.username || '' });
      } catch (e) {
        console.error(e);
        if (!cancelled) setMe({ loaded: true, uid: null, email: '', role: 'viewer', sucursalId: null, username: '' });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return me;
}
